import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppSignals } from '@appShared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

@Component({
    selector: 'app-error',
    template: `
    <div class="text-center mt-3 mb-5">
      <h2 class="text-error">ERROR OCCURRED</h2>
      <p class="mx-auto text-center">
        We are sorry, an error has occurred:<br/>
        <span class="fw-bold">{{error}}</span><br/><br/>
        Please go back to the home page, or contact us at
            <a href="mailto:customercare@southwesternadvantage.com" class="contact font-weight-bold">customercare&#64;southwesternadvantage.com</a>
      </p>
      <div class="mt-4 mb-5">
        <a [routerLink]="[dashboardUri]" class="btn btn-large btn-primary">GO TO HOMEPAGE</a>
      </div>
    </div>
  `,
    styles: [`
      h2 {
        font-size: 40px;
        font-weight: 700;
        color: blue;
      }
      p { max-width: 400px; }
      a.contact, a.contact:hover, a.contact:focus, a.contact:visited {
        color: #029edb;
        text-decoration: none;
      }
  `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink]
})

export class ErrorComponent {
   error = inject(AppSignals).error() || 'An unknown error has occurred'
   /* root, not a guarded route - guards bounce a failing session straight back here */
   dashboardUri = SITE_DIRECTORY_ROUTES.uri
}
